import { Store } from '@core/types'

const showChange = (name: string, c: any) => {
    console.debug(
        `%c[${name} store change]`,
        'font-size:1.1em;font-weight: bold',
        c
    )
}

export class StoreDebugger {
    readonly stores: [string, Store<any>][] = []

    addStores = (stores: Record<string, Store<any>>) => {
        Object.entries(stores).forEach(([name, s]) => this.addStore(name, s))
    }

    addStore = (name: string, s: Store<any>) => {
        this.stores.push([name, s])
    }

    startShowingChanges = () => {
        this.stores.forEach(([name, s]) => {
            s.changes().subscribe(c => {
                showChange(name, c)
            })
        })
    }
}
